import React from "react";
import { marigoldPetals } from "../../data/homeContent";
export function MarigoldPetals({
  className = ""
}: {
  className?: string;
}) {
  return <div aria-hidden="true" className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} data-id="element-89" data-mp="rbhhignhxck2">
      {marigoldPetals.map(petal => <span key={petal.left} className="marigold-petal absolute top-0 block rounded-[60%_40%_60%_40%]" style={{
      left: petal.left,
      width: petal.size,
      height: petal.size * 1.4,
      backgroundColor: petal.color,
      animationDuration: `${petal.duration}s`,
      animationDelay: `${petal.delay}s`
    }} data-id="element-90" data-mp="hdbjwb8q2sl0" />)}
    </div>;
}